// Helpers shared by the Watch page and the game viewer.
export const TURN_LIMIT = 15;

export function ago(iso) {
  if (!iso) return "";
  const s = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function nameOf(g, id) {
  if (id === g.player1_id) return g.player1_username;
  if (id === g.player2_id) return g.player2_username;
  return null;
}

// "mira captured the flag", "tobes won on turns", ...
export function resultText(g) {
  if (g.win_type === "draw") return `${g.player1_username} and ${g.player2_username} agreed a draw`;
  const winner = nameOf(g, g.winner_id);
  const loser = g.winner_id === g.player1_id ? g.player2_username : g.player1_username;
  if (!winner) return "Game over";
  switch (g.win_type) {
    case "capture": return `${winner} captured the flag`;
    case "turns": return `${winner} won on turns`;
    case "sealed": return `${winner} won on proximity`;
    case "timeout": return `${winner} won when the clock ran out`;
    case "resign": return `${winner} won, ${loser} resigned`;
    case "abandonment": return `${winner} won, ${loser} left`;
    default: return `${winner} won`;
  }
}

// [row, col, side] from the server as the "r,c" map WatchBoard draws.
export function thumbTiles(list) {
  const out = {};
  (list || []).forEach(([r, c, side]) => { out[`${r},${c}`] = { side }; });
  return out;
}
